export default __webpack_public_path__ + "static/clients-928fcd10fcae125ed6b111a9eb066eeb.svg";